import { OmApplicationPopupModal, OmButton, OmIcon } from '@om/component-library-react';
import { setAllsureApplicationApiStatus } from '@om/redux/actions/allsureInsurance/referenceData';
import { API_CALL_STATUS } from '@om/redux/reducers/status';
import React from 'react';
import { useDispatch } from 'react-redux';

const ErrorModal = ({ open, exitable, onButtonClick,content }) => {
    // const dispatch = useDispatch()
    return (
        <OmApplicationPopupModal slot="error-modal" name="ErrorResponseModal" exitable={exitable} open={open}>
            <div slot="content">
                <OmIcon imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blt94f2cb596218bd62/5f2935c8ee8504335e705005/WRONG_CMOS.svg" />
                <h5 className="no-bottom-margin">Something Went Wrong</h5>
                <h6 className="no-bottom-margin account-verification-text">{content??'Please try again later'}</h6>
            </div>
            <OmButton slot="button" type="primary" size="large" text="Try again" onClick={onButtonClick} />
        </OmApplicationPopupModal>
    );
};

export default ErrorModal;
